<div class="body" [formGroup]="formGroup">

    <mat-form-field class="width" [appearance]="appearance">

        <mat-label class="label">Bezeichnung</mat-label>
        <input formControlName="customername" matInput placeholder="z.B. Kunde Wista Campus" [readonly]="!editMode" />

        <button mat-icon-button matSuffix [disabled]="!editMode || !customerNameControl.value" color="warn" (click)="clearName()">
            <mat-icon>clear</mat-icon>
        </button>

    </mat-form-field>

    <ng-container *ngIf="doubletService && (doubletService.checkerVisible$|async)">

        <app-doublet-checker></app-doublet-checker>

    </ng-container>

    <div class="content grid-content-2">

        <div class="section">

            <div class="row">

                <mat-form-field class="width" [appearance]="appearance">
                    <mat-label class="label">Kundennummer</mat-label>
                    <input formControlName="customernumber" matInput placeholder="Kundennummer" [readonly]="!editMode" />
                    <button *ngIf="editMode && showIdGenerator" mat-icon-button matSuffix matTooltip="Automatisch erzeugen" (click)="setAutoCustomerNumber()">
                        <mat-icon>adb</mat-icon>
                    </button>
                </mat-form-field>

                <mat-checkbox formControlName="customeractive">
                    Aktiver Kunde
                </mat-checkbox>

            </div>

            <mat-form-field class="width" [appearance]="appearance">
                <mat-label class="label">Telefonnummer</mat-label>
                <mat-icon matPrefix class="icon">local_phone</mat-icon>
                <input formControlName="customerphone" matInput placeholder="Telefonnummer" [readonly]="!editMode" />
            </mat-form-field>

            <mat-form-field class="width" [appearance]="appearance">
                <mat-label class="label">Fax Nummer</mat-label>
                <mat-icon matPrefix class="icon">dialpad</mat-icon>
                <input formControlName="customerfax" matInput placeholder="Fax Nummer" [readonly]="!editMode" />
            </mat-form-field>

            <mat-form-field class="width" [appearance]="appearance">
                <mat-label class="label">E-Mail Adresse</mat-label>
                <mat-icon matPrefix class="icon">alternate_email</mat-icon>
                <input formControlName="customermail" matInput placeholder="E-Mail Adresse" [readonly]="!editMode" />
            </mat-form-field>

        </div>

        <div class="section quill-wrapper quill-wrapper-white-toolbar quill-wrapper-graduated-bg">

            <quill-editor formControlName="customernote" [modules]="modules"></quill-editor>

        </div>

    </div>

</div>